import React from "react";

import { Card, Heading, Inline, Stack, Text } from "@origin-digital/ods-core";

import ChargerIllustration from "@/assets/charger.svg";
import { IconSolarEnergyGenerated } from "@/components/icons";
import { IIBatterUsageResponse } from "@/contract/generated/electrify-v1";
import { formatLabel } from "@/utils";

import { batteryNotSupported as content } from "./content.json";

export const BatteryNotSupported = ({
  batteryOutlook,
}: {
  batteryOutlook: IIBatterUsageResponse;
}) => {
  const { extraCapacityRequired } = batteryOutlook;

  return (
    <Stack space="large">
      <Stack space="medium">
        <Heading variant="h2" weight="medium" tone="primaryB">
          {content.heading}
        </Heading>
        <Text tone="neutralDark" variant="subtitle-small">
          {content.description}
        </Text>
      </Stack>

      <Inline space="medium" alignY="top" disableWrap={true}>
        <ChargerIllustration alt="Lightning bolt icon" />
        <Stack space="small">
          <Text tone="neutralDark">
            <b>{content.outcome.heading}</b>
          </Text>
          <Text tone="neutralDark">{content.outcome.description}</Text>
        </Stack>
      </Inline>

      <Card outline={true}>
        <Inline space="xsmall" alignY="top" disableWrap={true}>
          <IconSolarEnergyGenerated color="secondary" />
          <Stack space="small">
            <Text tone="neutralDark">
              <b>{content.solarGenerationNeeded.heading}</b>
            </Text>
            <Text>
              {formatLabel(
                content.solarGenerationNeeded.capacityRequired,
                (value) => (
                  <b>{value}kW of solar capacity</b>
                ),
                extraCapacityRequired!
              )}
            </Text>
            <Text>{content.solarGenerationNeeded.talkToExperts}</Text>
          </Stack>
        </Inline>
      </Card>
    </Stack>
  );
};
